module.exports = __webpack_public_path__ + "static/media/gymnastics.bc58ba65.svg";